import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import EditClientModal from 'scenes/ClientDetail/components/EditClientModal'

import { 
  RESEND_EMAIL_URL, PASSWORD_RECOVERY_URL, USER_PROFILE_URL,
  CLIENT_VEHICLES_CSV_URL, ACTIVATE_SET_PASSWORD_URL,
  USER_PRIVILEGES_URL, DELETE_CLIENT_URL
} from 'constants'

import { statusChanged } from 'components/RequestStatus/actions'
import { updateUserData } from 'scenes/ClientDetail/actions'

import ConfirmationPhraseModal from 'components/ConfirmationPhraseModal'

import './styles.scss'

export class DropDown extends BaseComponent {

  constructor() {
    super()
    this.state = {
      has_delete_client: false
    }
    this._bind( '_showEditData', '_resendConfirmation', '_sendRecoverPassword',
                '_disableAccount', '_renderResendConfirmation', '_renderIsActive',
                '_renderSendRecoverPassword', '_renderDownloadVehicles', '_downloadVehicles',
                '_renderActivateAndSetPassword', '_activateAndSetPassword', '_confirmDeleteClient',
                '_getUserPrivileges', '_deleteClient')
  }

  componentDidMount() {
    this._getUserPrivileges()
  }

  _renderResendConfirmation() {
    return this.props.user.is_active ? null : (
      <li onClick={this._resendConfirmation} className="d-flex align-items-center justify-content-left">
        <i className="material-icons">email</i>
        <span>Reenviar mail de confirmación</span>
      </li>
    )
  }

  _confirmDeleteClient() {
    var title = "Confirmación para eliminar cliente"
    var message = "Se eliminarán todos los coches, documentos, pólizas y siniestros del cliente."
    var phrase = "ELIMINAR CLIENTE"
    this.context.toggleModal(
      true,
      <ConfirmationPhraseModal 
                          _onAccept={this._deleteClient.bind(this)}
                          match={this.props.match} 
                          title={title}
                          acceptLabel="Eliminar"
                          message={message}
                          phrase={phrase}
                          hideModal={true}
      />
    )
  }

  _renderIsActive() {
    return this.props.user.is_active ? (
      <li onClick={this._disableAccount} className="d-flex align-items-center justify-content-left block-account">
        <i className="material-icons">block</i>
        <span>Desactivar cuenta</span>
      </li>
    ) : null
  }

  _renderDeleteClient() {
    return (this.props.client.user_type === 'Broker' && this.state.has_delete_client ) ? (
      <li onClick={this._confirmDeleteClient} className="d-flex align-items-center justify-content-left block-account">
        <i className="material-icons">delete_forever</i>
        <span>Eliminar Cliente</span>
      </li>
    ) : null
  }

  _renderSendRecoverPassword() {
    return this.props.client.is_active ? (
      <li onClick={this._sendRecoverPassword} className="d-flex align-items-center justify-content-left">
        <i className="material-icons">vpn_key</i>
        <span>Enviar mail para recuperar contraseña</span>
      </li>
    ) : null
  }

  _renderDownloadVehicles(){
    return (
      <li onClick={this._downloadVehicles} className="d-flex align-items-center justify-content-left">
        <i className="material-icons">file_download</i>
        <span>Descargar relación de vehículos</span>
      </li>
    )
  }

  _renderActivateAndSetPassword() {
    return this.props.client.user_type === 'Broker' ? (
      <li onClick={this._activateAndSetPassword} className="d-flex align-items-center justify-content-left">
        <i className="material-icons">vpn_key</i>
        <span>Activar y asignar contraseña</span>
      </li>
    ) : null
  }

  _showEditData() {
    this.context.toggleModal(true,
      <EditClientModal user={this.props.user} client={this.props.client}/>
    )
  }

  _resendConfirmation() {
    this.props.updateRequestStatus('progress', 'Reenviando email..')
    request(RESEND_EMAIL_URL(this.props.user.uuid), {
      method: 'POST'
    })
      .then((res) => {
        this.props.updateRequestStatus(res.status, res.message)
      })
      .catch(({response}) => {
        const status = response ? response.status : 'error'
        const message = response ? response.message : 'Algo salió mal, no pudimos enviar el email'
        this.props.updateRequestStatus(status, message)
      })
  }

  _sendRecoverPassword() {
    this.props.updateRequestStatus('progress', 'Reenviando email..')
    request(PASSWORD_RECOVERY_URL, {
      method: 'POST',
      body: {
        email: this.props.user.email
      }
    })
      .then((res) => {
        this.props.updateRequestStatus(res.status, res.message)
      })
      .catch(({response}) => {
        this.props.updateRequestStatus('error', 'Algo salió mal, no pudimos enviar el email')
      })
  }

  _activateAndSetPassword() {
    this.props.updateRequestStatus('progress', 'Activando cuenta..')
    request(ACTIVATE_SET_PASSWORD_URL(this.props.user.uuid), {
      method: 'POST',
      body: {}
    })
      .then((res) => {
        this.props.updateRequestStatus(res.status, res.message)
        window.location.reload(false)
      })
      .catch(({response}) => {
        let m = 'Algo salió mal, no pudimos activar la cuenta'
        if (response.message && response.message.length !== 0) {
          m = response.message
        } 
        this.props.updateRequestStatus('error', m)
      })
  }

  _downloadVehicles(){
    request(CLIENT_VEHICLES_CSV_URL(this.props.user.uuid))
    .then(( res ) => {
        var csv = res.csv
        var hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = res.filename
        hiddenElement.click()
    })
    .catch(console.error)
  }

  _disableAccount() {
    this.props.updateRequestStatus('progress', 'Desactivando cuenta..')
    const user = this.props.user
    request(USER_PROFILE_URL(user.uuid), {
      method: 'PUT',
      body: {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        is_active: false
      }
    })
      .then((res) => {
        this.props.updateRequestStatus(res.status, res.message)
        this.props.updateUserData(res.user)
      })
      .catch(({response}) => {
        this.props.updateRequestStatus('error', 'Algo salió mal, no pudimos enviar el email')
      })
  }

  _getUserPrivileges() {
    request(USER_PRIVILEGES_URL, {
      method: 'GET'
    })
      .then((res) => {
        if (res.hasOwnProperty('has_delete_client')) {
          this.setState({ has_delete_client: res.has_delete_client })
        }
      })
      .catch(({response}) => {
        console.log('error on get privileges ....')
      })
  }

  _deleteClient() {
    this.props.updateRequestStatus('progress', 'Eliminando cliente..')
    request(DELETE_CLIENT_URL(this.props.user.uuid), {
      method: 'DELETE',
      body: {}
    })
      .then((res) => {
        this.props.updateRequestStatus(res.status, res.message)
        setTimeout(() => {
          window.location.href = '/clientes'
        }, 2000)
      })
      .catch(({response}) => {
        let m = 'Algo salió mal, no pudimos eliminar el cliente.'
        this.props.updateRequestStatus('error', m)
      })
  }

  render() {
    return (
      <div id="DropDown" className="dropdown pop-control d-flex align-items-center justify-content-center">
        <i className="material-icons">more_horiz</i>
        <i  id="dropdownMenuButton"
            className="material-icons dropdown-toggle"
            type="button"  data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">more_horiz</i>
        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          <i className="material-icons arrow-drop">arrow_drop_up</i>
          <ul>
            <li onClick={this._showEditData} className="d-flex align-items-center justify-content-left">
              <i className="material-icons">edit</i>
              <span>Editar datos de cuenta</span>
            </li>
            {this._renderResendConfirmation()}
            {this._renderSendRecoverPassword()}
            {this._renderDownloadVehicles()}
            {this._renderActivateAndSetPassword()}
            {this._renderIsActive()}
            {this._renderDeleteClient()}
          </ul>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserData: (user) => dispatch(updateUserData(user)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(null, mapDispatchToProps)(DropDown)

DropDown.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/DropDown/index.js